import Helmet from "react-helmet";
function Meta(props) {

    return (
        <div className="metasec">
        <Helmet> 
            <title>{props.title}</title>
            <meta name="description" content="props.description" />
            <meta name="keyword" content="props.keyword" /> 
        </Helmet>
        </div>


    );
}

export default Meta;